import React from 'react';
import { Route } from 'react-router-dom';
import lazyLoad from 'utils/lazyLoad';
import { getPathsForGwtPlace } from 'utils/navigation';
import { useSelector } from 'react-redux';
import { hasViewMenuDeveloper } from 'selectors/permissions';
import { UnauthorizedPageAccess } from './utils';

const XAgentManager = lazyLoad(
  () => import(/* webpackChunkName: "XAgentManager" */ 'pages/XAgentManager'),
);

export default function useXAgentRoutes() {
  const canAgent = useSelector(hasViewMenuDeveloper);
  return [
    <Route
      path={getPathsForGwtPlace('xAgentManager')}
      component={canAgent ? XAgentManager : UnauthorizedPageAccess}
    />,
  ];
}
